// src/config/razorpay.js

// Razorpay Configuration using environment variables
export const RAZORPAY_KEY_ID = process.env.REACT_APP_RAZORPAY_KEY_ID;
export const RAZORPAY_KEY_SECRET = process.env.REACT_APP_RAZORPAY_KEY_SECRET;

export const getRazorpayKey = () => {
  return RAZORPAY_KEY_ID;
};

export const getRazorpaySecret = () => {
  return RAZORPAY_KEY_SECRET;
}; 
